import { mapState } from 'vuex'

export default {
  components: {
    TTableImport: () => import('@/components/tables/import'),
    TTablePeople: () => import('@/components/tables/people'),
    TFormsFilter: () => import('@/components/forms/filter'),
    TCampaign: () => import('@/components/forms/campaign/'),
    TDashboard: () => import('@/components/dashboard')
  },

  data() {
    return {
      hideBack: false,
      activeIndex: 0,
      currentIndex: 0,
      titleButton: "",
      disabledTab: false
    }
  },

  computed: {
    ...mapState({
      filter: ({ people }) => people.filter,
      title: ({ breadcrumb }) => breadcrumb.titleBreadcrumb
    })
  },

  methods: {
    actionButton () {
      // if (this.currentIndex === 2) {
      if (this.currentIndex === 3) {
        this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL_EXPORT', true)
      } else {
        this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL', true)
      }
    },

    handleChange (e, activePane, index) {
      this.currentIndex = +index;
      this.$store.commit('statusBar/TOGGLE_STATUS_BAR', false)
      this.button()
      if (this.currentIndex === 0 || this.currentIndex === 1) {
        this.titleButton = ''
      }
    },

    button () {
      this.titleButton = this.currentIndex === 3 ? "Exportar" : "Importar arquivos"
    }
  },

  mounted () {

    const newCampaign =  this.$route.params.id
    if (newCampaign === 'new') {
      this.disabledTab = true
    }
  },
}
